<footer>
    <p class="font-w-500">
        ReparaGo - &copy;Todos los derechos reservados {{anio}}
    </p>
</footer>